import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {

    saveApplication(appDto, appId) {
        axios.defaults.withCredentials = true;


        return axios.post(constants.BASE_URL + "/applications/" + appId, appDto).then(response => {
            return response.data;

        }).catch(error => {
            return error.response.data;
        });
    },
    getApplicationDetails(appId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/" + appId + "/edit")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                
            });
    },
    getProcesses(appId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/" + appId + "/appprocesses/application-processes")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                EventBus.$emit('error-notification', {
                    "msg": error.message
                });
            });
    },
    getForms(appId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/" + appId + "/appforms/all-forms-application")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                EventBus.$emit('error-notification', {
                    "msg": error.message
                });
            });
    },
    exportAsPDF(appId, appName) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/export/" + appId+"?timezone="+Intl.DateTimeFormat().resolvedOptions().timeZone)
            .then(response => {
                var binaryString = window.atob(response.data.data);
                var binaryLen = binaryString.length;
                var bytes = new Uint8Array(binaryLen);
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i);
                    bytes[i] = ascii;
                }
                var blob = new Blob([bytes], { type: "application/pdf" });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = appName + '.pdf';
                link.click();
            })
            .catch(error => {
                EventBus.$emit('error-notification', {
                    "msg": error.message
                });
            });
    },
    deployApplication(appId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/deploy/" + appId)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error.response.data;
            });
    },
    unDeployApplication(appId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/undeploy/" + appId)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error.response;
            });
    },
    disableApplication(appId, deletedReason) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/applications/" + appId + "/delete", {"deletedReason":deletedReason}).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    enableApplication(appId) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/applications/" + appId + "/restore").then(response => {
            return response.data;
        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    getAppliations(input) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/applications?" + input, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching applications"
                    });
                }
            });
    },
    getApplicationLabels() {
        return axios.get(constants.BASE_URL + "/applications/all-labels", {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
    getCustomerOrganizations(offset = 0, limit = 20) {
        return axios.get(constants.BASE_URL + "/admin/tenant", {
            withCredentials: true,
            params: {
                offset,
                limit
            }
        }).then(response => {
            return response.data;
        });
    },
    getAssignedCustomerOrganizations(appId, offset = 0, limit = 20) {
        return axios.get(constants.BASE_URL + "/admin/applications/" + appId + "/tenant/status", {
            withCredentials: true,
            params: {
                offset,
                limit
            }
        }).then(response => {
            return response.data;
        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": "Unable to fetch assigned customer organisations"
            });
        });
    },
    assignApplicationToCustomerOrganizations(appId, requestPayload) {
        return axios.post(
            constants.BASE_URL + "/admin/applications/" + appId + "/assign",
            requestPayload,
            { withCredentials: true }
        )
        .then(response => {
            return response.data || {};
        })
        .catch(error => {
            var errorMessages = "";
            if (!error.response) {
                errorMessages = "Network error. Please check your connection.";
                error.customMessage = errorMessages;
                throw error;
            }
            const status = error.response.status;
            if (status === 404) {
                errorMessages = "Source Application not found.";
            }
            else if (status === 500) {
                errorMessages = "Internal Server error while assigning application.";
            }
            else if (status === 400) {
                errorMessages = "Unable to assign application to customer organisations.";
            }
            else {
                errorMessages = "Unable to assign application to customer organisations.";
            }
            error.customMessage = errorMessages;
            console.error('Assign application failed:', error);
            throw error;
        });
    },
    validateAssignOperation(appId, requestPayload) {
        //return Promise.resolve([]);
        return axios.post(
            constants.BASE_URL + "/admin/applications/" + appId + "/assign/validate",
            requestPayload,
            { withCredentials: true }
        )
        .then(response => {
            return response.data || {};
        })
        .catch(error => {
            var errorMessages = "";
            if (!error.response) {
                errorMessages = "Network error. Please check your connection.";
                error.customMessage = errorMessages;
                throw error;
            }
            const status = error.response.status;
            if (status === 404) {
                errorMessages = "Unable to assign application from customer organisations.";
            }
            else if (status === 500) {
                errorMessages = "Internal Server error while assigning application.";
            }
            else if (status === 400) {
                errorMessages = "Unable to assign application to customer organisations.";
            }
            else {
                errorMessages = "Unable to assign application to customer organisations.";
            }
            error.customMessage = errorMessages;
            console.error('Assign application failed:', error);
            throw error;
        });
    },
    unassignApplicationFromCustomerOrganizations(appId, requestPayload) {
        return axios.post(
            constants.BASE_URL + "/admin/applications/" + appId + "/unassign",
            requestPayload,
            { withCredentials: true }
        )
        .then(response => {
            return response.data || {};
        })
        .catch(error => {
            var errorMessages = "";
            if (!error.response) {
                errorMessages = "Network error. Please check your connection.";
                error.customMessage = errorMessages;
                throw error;
            }
            const status = error.response.status;
            if (status === 404) {
                errorMessages = "Unable to unassign application from customer organisations.";
            }
            else if (status === 500) {
                errorMessages = "Internal Server error while unassigning application.";
            }
            else if (status === 400) {
                errorMessages = "Unable to unassign application from customer organisations.";
            }
            else {
                errorMessages = "Unable to unassign application to customer organisations.";
            }
            error.customMessage = errorMessages;
            console.error('Unassign application failed:', error);
            throw error;
        });
    },
    getCopyApplicationDetails(appId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/" + appId + "/copy")
            .then(response => {
                return response.data;
            })
            .catch(error => {
               
            });
    },
    checkDeploymentExpired() {
        return axios.get(constants.BASE_URL + "/applications/deployment-expired", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error.response;
            });
    }
}
